import { render, staticRenderFns } from "./CBSQueue.vue?vue&type=template&id=3bf3e6e5&"
import script from "./CBSQueue.vue?vue&type=script&lang=js&"
export * from "./CBSQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports